export default {
  POOR: 'POOR',
  AVERAGE: 'AVERAGE',
  GOOD: 'GOOD',
} as const
